export const Visa = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="20"
    viewBox="0 0 28 20"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="27" height="19" rx="3.5" fill="white" />
    <rect x="0.5" y="0.5" width="27" height="19" rx="3.5" stroke="#F2F4F7" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.85333 13.2152H7.15707L5.88509 8.16031C5.82471 7.92779 5.69652 7.72222 5.50796 7.62534C5.03737 7.38186 4.51882 7.18809 3.95312 7.09036V6.89575H6.68566C7.06279 6.89575 7.34564 7.18809 7.39278 7.52761L8.05276 11.1739L9.74819 6.89575H11.3973L8.85333 13.2152ZM12.3401 13.2152H10.7382L12.0573 6.89575H13.6593L12.3401 13.2152ZM15.7318 8.64643C15.779 8.30606 16.0618 8.11145 16.3918 8.11145C16.9104 8.06259 17.4752 8.16032 17.9466 8.40295L18.2295 7.04234C17.7581 6.84773 17.2395 6.75 16.7689 6.75C15.2141 6.75 14.0827 7.62534 14.0827 8.8402C14.0827 9.7644 14.8841 10.2497 15.4498 10.542C16.0618 10.8335 16.2975 11.0281 16.2504 11.3196C16.2504 11.7569 15.779 11.9515 15.3084 11.9515C14.7427 11.9515 14.177 11.8057 13.6593 11.5623L13.3764 12.9237C13.9421 13.1663 14.5541 13.2641 15.1198 13.2641C16.8632 13.3121 17.9466 12.4376 17.9466 11.125C17.9466 9.47206 15.7318 9.37518 15.7318 8.64643ZM23.5531 13.2152L22.2811 6.89575H20.9149C20.632 6.89575 20.3492 7.09036 20.2549 7.38186L17.8995 13.2152H19.5486L19.8778 12.2918H21.904L22.0926 13.2152H23.5531ZM21.1506 8.59757L21.6212 10.9793H20.302L21.1506 8.59757Z"
      fill="#172B85"
    />
  </svg>
);
